import { forwardRef, type ForwardRefExoticComponent } from "react";
import {
  Link as MUIBaseLink,
  type LinkProps as MUILinkProps,
} from "@mui/material";
import { createLink, type LinkComponentProps } from "@tanstack/react-router";

const MUILink = forwardRef<HTMLAnchorElement, MUILinkProps>(
  ({ ...rest }, ref) => <MUIBaseLink ref={ref} {...rest} />
);

const CreatedLinkComponent = createLink(MUILink);

export type LinkProps = LinkComponentProps<typeof MUILink>;
export const Link: ForwardRefExoticComponent<LinkProps> = forwardRef<
  any,
  LinkProps
>((props, ref) => (
  <CreatedLinkComponent preload="intent" ref={ref} {...props} />
));
